import { useTranslation } from 'react-i18next';
import type { WithholdingRate } from '../../types/bookkeeping.js';

export interface PayBillWithholdingFormValue {
  bill_id: string;
  withholding_rate_id: string;
  amount: string; // bigint minor units as string
}

export interface PayBillWithholdingRowProps {
  index: number;
  value: PayBillWithholdingFormValue;
  billOptions: Array<{ id: string; number: string }>;
  withholdingRates: WithholdingRate[];
  canRemove: boolean;
  onChange: (v: PayBillWithholdingFormValue) => void;
  onRemove: () => void;
}

export function PayBillWithholdingRow({
  value,
  billOptions,
  withholdingRates,
  canRemove,
  onChange,
  onRemove,
}: PayBillWithholdingRowProps) {
  const { t } = useTranslation('bookkeeping');

  return (
    <tr className="border-b">
      {/* Bill picker (must be one of the applied bills) */}
      <td className="px-2 py-1">
        <select
          value={value.bill_id}
          onChange={(e) => onChange({ ...value, bill_id: e.target.value })}
          className="w-full min-w-36 rounded border px-1 py-0.5 text-sm"
        >
          <option value="">— {t('purchases.bills.title')}</option>
          {billOptions.map((b) => (
            <option key={b.id} value={b.id}>
              {b.number}
            </option>
          ))}
        </select>
      </td>
      {/* Withholding rate picker */}
      <td className="px-2 py-1">
        <select
          value={value.withholding_rate_id}
          onChange={(e) => onChange({ ...value, withholding_rate_id: e.target.value })}
          className="w-full min-w-36 rounded border px-1 py-0.5 text-sm"
        >
          <option value="">— {t('sales.receive_payments.withholdings')}</option>
          {withholdingRates.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name} ({r.code})
            </option>
          ))}
        </select>
      </td>
      {/* Amount */}
      <td className="px-2 py-1">
        <input
          value={value.amount}
          onChange={(e) => onChange({ ...value, amount: e.target.value })}
          placeholder="0"
          className="w-28 rounded border px-1 py-0.5 text-sm"
        />
      </td>
      {/* Remove */}
      <td className="px-2 py-1">
        <button
          type="button"
          onClick={onRemove}
          disabled={!canRemove}
          className="text-red-600 hover:text-red-700 disabled:cursor-not-allowed disabled:opacity-30"
          title="Eliminar retención"
        >
          ×
        </button>
      </td>
    </tr>
  );
}
